"use strict";

var _typeof = require("/builds/globalhop/dashboard/node_modules/@babel/runtime/helpers/typeof");

var compose = require('redux').compose;

exports.__esModule = true;
exports.composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return undefined;
  if (_typeof(arguments[0]) === 'object') return compose;
  return compose.apply(null, arguments);
};
exports.devToolsEnhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
  return function (noop) {
    return noop;
  };
};